import getCurrentUserIdAndRole from './getCurrentUserIdAndRole';
import makeDeduplicatedFunction from './makeDeduplicatedFunction';

const getCurrentUserIdAndRoleDeduplicated = makeDeduplicatedFunction(getCurrentUserIdAndRole);

export default getCurrentUserIdAndRoleDeduplicated;
